/* ============================================================
   BDP — Crossfade lento de fotos
   Cada [data-bdp-crossfade] alterna os filhos .bdp-heritage__photo
   (ou o seletor em data-bdp-crossfade-item) "aos poucos": troca a
   cada 4.5s com fade de 1.6s (CSS). Pausa fora da viewport
   (IntersectionObserver) e não anima com prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  var INTERVAL_MS = 4500;

  function bind(stage) {
    if (stage.dataset.bdpFadeBound) return;
    var selector = stage.dataset.bdpCrossfadeItem || '.bdp-heritage__photo';
    var items = stage.querySelectorAll(selector);
    if (items.length < 2) return;
    stage.dataset.bdpFadeBound = 'true';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var current = 0;
    var timer = null;

    function tick() {
      var next = (current + 1) % items.length;
      items[current].classList.remove('is-active');
      items[next].classList.add('is-active');
      current = next;
    }

    function start() {
      if (timer === null) timer = window.setInterval(tick, INTERVAL_MS);
    }

    function stop() {
      if (timer !== null) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) start();
          else stop();
        });
      }, { threshold: 0.15 }).observe(stage);
    } else {
      start();
    }

    // aba em segundo plano não acumula trocas
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else if (stage.getBoundingClientRect().top < window.innerHeight) start();
    });
  }

  function init() {
    document.querySelectorAll('[data-bdp-crossfade]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
